import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_UpcomingVestingGrantsDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import { type TableParamsType } from '../../types/common';

const useGetUpcomingOptionsVestingList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_UpcomingVestingGrantsDto | undefined,
  unknown
> => {
  const { sorting, skipCount, maxResultCount, filter } = tableInfo;
  const upcomingOptionsVestingList = useQuery(
    ['getUpcomingOptionsVestingList', sorting, skipCount, maxResultCount, filter],
    async () => {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardUpcomingVestingGrants(
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return upcomingOptionsVestingList;
};

export default useGetUpcomingOptionsVestingList;
